import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_BODY_ROW_CELL_CLASS_NAME = 'TableBodyRowCell';

export const TABLE_BODY_ROW_CELL_CLASS_SLOTS = ['root'] as const;

export type TableBodyRowCellClassSlot =
	(typeof TABLE_BODY_ROW_CELL_CLASS_SLOTS)[number];

export interface TableBodyRowCellClasses {
	root: string;

	isActionCell: string;
}

export type TableBodyRowCellClassKey = keyof TableBodyRowCellClasses;

export const getTableBodyRowCellUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_BODY_ROW_CELL_CLASS_NAME, slot);

export const tableBodyRowCellClasses = generateUtilityClasses<
	keyof TableBodyRowCellClasses
>(TABLE_BODY_ROW_CELL_CLASS_NAME, ['root', 'isActionCell']);
export default tableBodyRowCellClasses;
